import { useEffect, useState } from 'react';

export function useKeyPressed(targetKey: string) {
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    if (!targetKey) {
      return () => {};
    }

    const normalizedTarget = targetKey.toLowerCase();

    const down = (event: KeyboardEvent) => {
      if (event.key?.toLowerCase() === normalizedTarget) {
        setPressed(true);
      }
    };

    const up = (event: KeyboardEvent) => {
      if (event.key?.toLowerCase() === normalizedTarget) {
        setPressed(false);
      }
    };

    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);

    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
    };
  }, [targetKey]);

  return pressed;
}
